import React from 'react'

import Grid from '@material-ui/core/Grid'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core/styles'

import { IAchievement } from 'protos'

import AchievementListItem from '../AchievementListItem'

interface Props {
  achievements: IAchievement[]
}

const styles = (theme: Theme) => createStyles({
  item: {
    paddingTop: theme.spacing() * 2,
    paddingBottom: theme.spacing() * 2,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const AchievementList: React.SFC<InjectedProps> = ({ classes, achievements }) => (
  <Grid direction="row" container>
    {achievements.map((achievement) => (
      <AchievementListItem
        className={classes.item}
        achievement={achievement}
        key={achievement.achievementId!}
        xs={6}
      />
    ))}
  </Grid>
)

export default withStyles(styles)(AchievementList)
